var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "chat-menu" } },
    [
      _c(
        "div",
        { staticClass: "conv-head" },
        [
          _c(
            "md-button",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    followCursor: true,
                    placement: "bottom-end",
                    theme: _vm.isDarkMode ? "light-border" : "google",
                  },
                  expression:
                    "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
                },
              ],
              staticClass: "new-group",
              attrs: { content: _vm.$t("message.addNewGroup") },
              on: { click: _vm.addNewChat },
            },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("group_add"),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "con-type" }, [
        _c(
          "span",
          {
            staticClass: "type",
            class: [_vm.selected === "all" && "selected-type"],
            on: { click: _vm.selectedThread },
          },
          [_vm._v(_vm._s(_vm.$t("message.all")))]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "type",
            class: [
              _vm.selected === "departments" && "selected-type-departments",
            ],
            on: { click: _vm.selectedDepartments },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("message.departments")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "type",
            class: _vm.selected === "groups" && "selected-type",
            on: { click: _vm.selectedGroups },
          },
          [_vm._v(_vm._s(_vm.$t("message.groups")))]
        ),
      ]),
      _vm._v(" "),
      _c("ChatList", { attrs: { selectedChatType: _vm.selected } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }